import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal, } from 'react-bootstrap';
import CasteForm from '../components/forms/CasteForm';
import '../styles/EmployeeMaster.css';
import CasteTable from '../components/CasteTable';

const CasteModel = () => {
     const navigate = useNavigate();
     const location = useLocation();

     const showModal = location.pathname === '/caste/add';

     const handleAddClick = () => {
          navigate('/caste/add');
     };

     const handleCloseModal = () => {
          navigate('/caste');
     };

     return (
          <div className="employee-master-page">
               <div className="employee-header">
                    <h2>Caste Master</h2>
                    <button className="add-employee-btn" onClick={handleAddClick}>
                         Add Caste
                    </button>
               </div>

               <CasteTable />

               <Modal
                    show={showModal}
                    onHide={handleCloseModal}
                    size="md"
                    centered
               >
                    <Modal.Header closeButton>
                         <Modal.Title>Add New Caste</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                         <CasteForm />
                    </Modal.Body>

               </Modal>
          </div>
     );
};

export default CasteModel;
